export default __webpack_public_path__ + "src/assets/Improve_Digital_Logo.png";